import React, { useCallback, useContext } from 'react'
import { priceFormatter, thousands } from '../../helpers/Numbers'
import SearchContext from '../context/SearchContext'

const Tags = () => {
	const { params, handleParams } = useContext(SearchContext)


	const getParams = useCallback( () => {
		/**
		 * Since tags can be combinations of params and also part of a param
		 * we need to map them...
		 */
		const paramMappings = {
			// query: {keys:['query'], type:'find', separator:' '},
			mileage: { keys: ['mileageMin', 'mileageMax'], type: 'toggle', formatter: thousands, unit: 'mil'},
			price: { keys: ['priceMin', 'priceMax'], type: 'toggle', formatter: thousands, unit: ' kr' },
			modelYear: {keys: ['modelYearMin', 'modelYearMax'], type:'toggle'},
			isCarrier: {keys: ['isCarrier'], type:'toggle', name: 'Transportbilar'},
			keywords: {keys:['keywords'], type:'find', separator:' '},
			modelSeries: {keys:['modelSeries'], type:'find', separator:', '},
			manufacturer: {keys:['manufacturer'], type:'find', separator:', '},
			gearboxType: {keys:['gearboxType'], type:'find', separator:', '},
			fuelType: {keys:['fuelType'], type:'find', separator:', '},
			color: {keys:['color'], type:'find', separator:', '},
			city: {keys:['city'], type:'find', separator:', '},
			segment: {keys:['segment'], type:'find', separator:', '},
			chassis: {keys:['chassis'], type:'find', separator:', '},
			leasingPrice: {keys: ['leasingPrice'],type: 'toggle', name:'Privatleasing'},
			state: {keys: ['state'], type:'toggle'},
		}
		const tagArray = []
		Array.from(Object.entries(paramMappings), ([key, settings]) => {

			const paramKeys = settings.keys.map( (key) => {
				return params.get(key)
			})

			// abort if empty
			if (paramKeys.join('').length === 0) return false;

			if (settings.type === 'toggle') {

				settings.name = settings.name 
									?? paramKeys.map(val => {
										return typeof settings.formatter === 'function' ? settings.formatter(val) : val
									}).join(' - ') + (settings?.unit ?? '')

				tagArray.push({key, settings})

			} else if ( settings.type === 'find') {
				if( paramKeys.length !== 1) { 
					console.log('This type only supports one field: ' + key) 
					return false
				}

				paramKeys[0].split(settings.separator).forEach( paramVal => { 
					const tagSettings = {
						name: paramVal
					}
					tagArray.push({key, settings: Object.assign(tagSettings,settings), value: paramVal})
				});
			}
		})

		return tagArray
		// return params.entries()

	}, [params])

	const qsReplaceAndHandle = useCallback( (tag) => {
		console.log(tag);
		const newParams = new URLSearchParams( params.toString())

		if(tag.settings.type === 'toggle') {
			tag.settings.keys.forEach(key => {
				newParams.delete(key)
			});

		} else if(tag.settings.type === 'find') {
			const newParam = params.get(tag.settings.keys[0])
				.split(tag.settings.separator)
				.filter( val => val !== tag.value)
				.join(tag.settings.separator)

			if (newParam.length === 0 ) {
				newParams.delete(tag.settings.keys[0]);
			} else {
				newParams.set(tag.settings.keys[0], newParam)
			}
		}
		handleParams(newParams)
	},[params])

	// const tags = useCallback(()=>{
	// 	params.
	// },[params])

	const labels = {
		color: 'Färg',
		gearboxType: 'Växellåda',
		segment: 'Kaross',
		fuelType: 'Motor',
		drivingWheel: 'Drivhjul',
		environmentClass: 'Miljöklass',
		manufacturer: 'Tillverkare',
		modelSeries: 'Modell',
	}

	return (
		<div className='tags'>
			{getParams().map( ( tag, i ) => {
				return (
					<span
						onClick={(e) => {
							qsReplaceAndHandle(tag)
						}}
						className='tag labeled'
						key={tag.key + '_' + i}
					>
						{tag.settings.name}
					</span>
				)
			})}
		</div>
	)
}
export default Tags
